import React, { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { createCheckoutSession, formatApiErrorDetail } from "@/lib/api";

/**
 * EnrollButton — triggers Stripe Checkout creation, then redirects.
 * Replaces any visual-only $997 CTA.
 */
export default function EnrollButton({
  children,
  className = "btn-aurora",
  testId = "enroll-button",
  source = "landing",
  packageId,
}) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function go() {
    const sessionPromise = createCheckoutSession({ package_id: packageId });
    setBusy(true);
    setErr("");
    try {
      const { url } = await sessionPromise;
      window.location.replace(url);
    } catch (e) {
      setErr(formatApiErrorDetail(e?.response?.data?.detail) || e.message);
      setBusy(false);
    }
  }

  return (
    <span className="inline-flex flex-col items-stretch sm:items-start gap-2">
      <button
        type="button"
        onClick={go}
        disabled={busy}
        data-testid={testId}
        data-source={source}
        className={`${className} disabled:opacity-70 disabled:cursor-not-allowed`}
      >
        {busy ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" /> REDIRECTING TO STRIPE…
          </>
        ) : (
          <>
            {children} <ArrowRight className="w-4 h-4" />
          </>
        )}
      </button>
      {err && <p className="text-rose-300 text-xs max-w-xs" data-testid={`${testId}-error`}>{err}</p>}
    </span>
  );
}
